import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, useLocation, Routes } from "react-router-dom";
import { Page } from "./types";
import Footer from "../components/Footer/Footer";
import MusicPlayer from "components/MusicPlayer/MusicPlayer";
import PageSingle from "app/(singles)/(default)/single/page";
import PageSpecial from "app/(singles)/(default)/single_special/page";
import PageSingleAudio from "app/(singles)/(default)/single-audio/page";
import PageArticles from "app/(articles)/add-articles/page";
import PageGetArticles from "app/(articles)/get-articles/page";
import PageGetAllArticles from "app/(articles)/get-all-articles/page";
import PageEditArticles from "app/(articles)/edit-articles/page";
import PageAbout from "app/about/page";
import Page404 from "app/not-found";
import PageLogin from "app/(others)/login/page";
import PageAddAccount from "app/(others)/account/page";
// import PageHomeDemo2 from "app/(home)/home-2/page";
// import PageHomeDemo3 from "app/(home)/home-3/page";
// import PageHomeDemo4 from "app/(home)/home-4/page";
import PageHomeDemo6 from "app/(home)/home-6/page";
import SiteHeader from "app/SiteHeader";
import cogoToast from "cogo-toast"
import PageSubCategory from "app/(archives)/category/subcategory"
import NotFound from "app/(archives)/NotFound/NotFound"
import PageHoroskop from "app/(archives)/horoskop/page"
import PageContact from "app/(others)/contact/page"
import {
  AdvertisingProvider,
  AdvertisingSlot,
  logVersionInfo
} from 'react-advertising';
import PageKuchnia from "app/(archives)/kuchnia/page"
import PageRegulamin from "app/(archives)/regulamin/page"
import PageRodo from "app/(archives)/rodo/page"
import PagePogoda from "app/pogoda/page"
import PageGazetaDecember from "app/(archives)/gazeta-grudzień/page"
import PageGazetaSanta from "app/(archives)/gazeta-świąteczna/page"
import PageGazetaNovember from "app/(archives)/gazeta-listopad/page"
import PageGazetaOctoberFirst from "app/(archives)/gazeta-pażdziernik-second/page"
import PageGazetaOctoberSecond from "app/(archives)/gazeta-pażdziernik-first/page"
import PageArticlesSection from "app/(articles)/articles-section/page"
import PageGazetaJanuary from "app/(archives)/gazeta-styczeń/page"
import PageGazetaFebuary from "app/(archives)/gazeta-luty/page"
import PageGazetaMarch from "app/(archives)/gazeta-marzec/page"
import PageAddManager from "app/(others)/manager/page"
import PageEditAdverts from "app/(articles)/edit-adverts/page"
import PageGetAllAdverts from "app/(articles)/get-all-adverts/page"
import PageGetAllMovies from "app/(articles)/get-all-movies/page"
import PageGetAllPodcasts from "app/(articles)/get-all-podcasts/page"
import PageAddPodcast from "app/(articles)/add-podcast/page"
import PageZdrowie from "app/(archives)/zdrowie/page"
import PageGazety from "app/(archives)/gazety/page"
import PageFilmy from "app/(archives)/filmy/page"
import { ArticlesProvider } from "../context/ArticlesContext"; // dostosuj ścieżkę
import PdfViewer from "app/(archives)/pdfViewer/pdfViewer"
import PagePopularne from "app/(archives)/popularne_artykuły/page"
import PageSignUp from "app/(others)/signup/page"
import PageAuthor from "app/author/page"
import PageAddFotos from "app/(articles)/add-fotos/page"
import PageDefaultLive from "app/(articles)/add-default-video/page"
import PageGetNewsletters from "app/(articles)/get-newsletters/page"
import PageOg from "app/(singles)/PageOg"
import PageAddNewspappers from "app/newspappers/add-newspappers/page"
import PageGetAllNewspappers from "app/newspappers/get-newspappers/page"
import PageSport from "app/(archives)/sport/page"
import PageCulture from "app/(archives)/kultura/page"
import PageNauka from "app/(archives)/nauka/page"
import PageGetAllYoutube from "app/(articles)/get-all-youtube/page"
import PageAddYoutubeVideos from "app/(articles)/add_youtube_videos/page"
import Instrukcja from "app/(archives)/instrukcja/page"



const user = JSON.parse(sessionStorage.getItem("user"));


const onPermission = () => {
  cogoToast.error("Nie masz uprawnień do tych funkcji")
}

const AuthorRoute = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  if (loading) {
    return null; // albo loader
  }

  if (user?.user?.type === "admin") {
    return <PageAuthor />;
  }

  return <PageHomeDemo6 />;
};


export const pages = [
  
  { path: "/", component: PageHomeDemo6 },
  { path: "/horoskop", component: PageHoroskop },
  { path: "/ResPublica grudzien swiateczny", component: PageGazetaSanta },
  { path: "/ResPublica styczeń", component: PageGazetaJanuary },
  { path: "/ResPublica luty", component: PageGazetaFebuary },
  { path: "/ResPublica marzec", component: PageGazetaMarch },
  { path: "/ResPublica grudzien", component: PageGazetaDecember },
  { path: "/ResPublica listopad", component: PageGazetaNovember },
  { path: "/ResPublica pażdziernika cześć 2", component: PageGazetaOctoberFirst },
  { path: "/ResPublica pażdziernika cześć 1", component: PageGazetaOctoberSecond },
  { path: "/kuchnia", component: PageKuchnia },
  { path: "/zdrowie", component: PageZdrowie },
   { path: "/sport", component: PageSport },
   { path: "/kultura", component: PageCulture },
   { path: "/nauka", component: PageNauka },
  { path: "/gazety", component: PageGazety },
  { path: "/filmy", component: PageFilmy },
  // { path: "/wybory/7", component: PageWybory },
  { path: "/:subcategory/:category/:subcategory_id/:category_id", component: PageSubCategory },
  { path: "/:category/:category_id", component: PageHomeDemo6 },
  { path: "/:subcategory/:subcategory_id", component: PageHomeDemo6 },

  // single page -------------------------------------------------------
  { path: "/:subcategory/:category/:subcategory_id/:category_id/artykuł/:id", component: PageSingle },
  // { path: "/:subcategory/:category/:subcategory_id/:category_id/wideo/:id", component: PageSingleVideo },
  { path: "/artykuł/:id", component: PageSpecial },
  { path: "/podcast/:id", component: PageSingleAudio },

   // articles -------------------------------------------------------
   { path: "/add-articles", component: PageArticles },
   { path: "/instrukcja", component: Instrukcja },
   { path: "/add-newspappers", component: PageAddNewspappers },
   { path: "/add-video-live", component: PageDefaultLive },
   { path: "/add-fotos", component: PageAddFotos },
   { path: "/add-podcasts", component: PageAddPodcast },
   { path: "/pdf", component: PdfViewer  },
   { path: "/get-articles", component: PageGetArticles }, 
   { path: "/get-all-articles", component: PageGetAllArticles },
   { path: "/get-all-newspappers", component: PageGetAllNewspappers },
   { path: "/get-all-youtube", component: PageGetAllYoutube },
   { path: "/get-newsletters", component: PageGetNewsletters },
   { path: "/get-all-movies", component: PageGetAllMovies },
   { path: "/get-all-podcasts", component: PageGetAllPodcasts },
   { path: "/articlesinHome", component: PageArticlesSection },
   { path: "/edit-articles/:id", component: PageEditArticles }, 
   { path: "/edit-adverts/:id", component: PageEditAdverts }, 
   { path: "/add-youtube", component: PageAddYoutubeVideos }, 
   { path: "/popularne", component: PagePopularne },
   { path: "/get-adverts", component: PageGetAllAdverts },
   { path: "/og/:id", component: PageOg },

  // other pages -------------------------------------------------------
  { path: "/about", component: PageAbout },
  { path: "/author", component: AuthorRoute },
  { path: "/regulamin", component: PageRegulamin },
  { path: "/pogoda", component: PagePogoda },
  { path: "/rodo", component: PageRodo },
  { path: "/contact", component: PageContact },
  { path: "/page404", component: Page404 },
  { path: "/login", component: PageLogin },
  { path: '*' , component:NotFound},
  { path: "/signup", component: PageSignUp },
  { path: "/add-account", component: PageAddAccount },
  { path: "/add-manager", component: PageAddManager },
]

const MyRoutes = () => {
  const[extended, setExtended] = useState(false)
  const[option, setOption] = useState("Rozwiń")

  return (
    <BrowserRouter>
    <ArticlesProvider>
      <SiteHeader />
      {/* <div style={{backgroundColor:"rgb(243, 243, 243)"}}> */}
      <Routes>
        {pages.map(({ component: Component, path }, index) => (
          <Route key={index} element={<Component />} path={path} />
        ))}
        <Route element={<Page404 />} />
      </Routes>
      {/* </div> */}
      <Footer />
      <MusicPlayer />
    </ArticlesProvider>
  </BrowserRouter>
  );
};

export default MyRoutes;
